import React from "react";
import apiClient from "../common/apiClient";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import InputTextField from "../components/textField/InputTextField";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification, CloseNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import "react-datepicker/dist/react-datepicker.css";
import TPEProgessiveSizeGuide from "../images/TPEProgressive.png";
import TPEUniformSizeGuide from "../images/TPEUniform.png";
import TPESymmetricalSizeGuide from "../images/TPESymmetrical.png";
import SiliconeProgressiveSizeGuide from "../images/SiliconeProgressive.png";
import SiliconeSymmetricalSizeGuide from "../images/SiliconeSymmetrical.png";
import SiliconeUniformSizeGuide from "../images/SiliconeUniform.png";
import TruSealConicalSizeGuide from "../images/TruSealConical.png";
import TruSealCylindricalSizeGuide from "../images/TruSealCylindrical.png";
import { Table } from "react-bootstrap";
import TextField from '@material-ui/core/TextField';
import ClearOrder from "../components/modal/ClearOrder";
import { ToCamelCase, IsInputExcessive, MultiFormNames } from '../common/common';

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class KneeBundleLinerSelection extends OrderFormStep {
  constructor(props) {
    super(props);

    this.formTypeId = 14;

    this.state = {
      isSubmit: false,
      linerInterfaces: [],
      linerSizes: [],
      linerProfiles: [],
      linerOptionCombinations: [],
      linerSuspensions: [],
      formState: {
        currentLiners: [],
        indexedCurrentLiners: [],
        linerPartNumber: new FieldState(false, ""),
        linerSuspension: new FieldState(false),
        linerInterface: new FieldState(false),
        linerSize: new FieldState(false),
        linerProfile: new FieldState(false),
        linerQuantity: new FieldState(false, 1),
        selectedLinerPartNumber: null,
      },
    };

    this.addLinerFromPartNumber = this.addLinerFromPartNumber.bind(this);
    this.addLinerFromSelection = this.addLinerFromSelection.bind(this);
    this.loadCart = this.loadCart.bind(this);
  }

  getSuspensionText(suspensionId) {
    return this.state.linerSuspensions.filter(c => c.id === suspensionId)[0]?.displayName;
  }

  async setServerLinerQuantity(partNumber, quantity) {
    const e = { target: { value: quantity } };
    if (!IsInputExcessive(e, "Quantity")) {
      let isMulti = null;
      if (this.props.productsAdded) {
        const productsAdded = await this.props.productsAdded();
        isMulti = this.checkIsMulti(productsAdded);
      }

      let url = `linerQuantity/${this.props.formTypeId}`;
      if (isMulti) {
        url = `linerQuantity/${this.props.formTypeId}?isMulti=${isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`;
      }

      apiClient.post(
        url,
        {
          partnumber: partNumber,
          quantity: quantity
        }
      ).then(response => {
        if (response.data.success) {
          this.loadCart();
        } else {
          CreateNotification(response.data.message, "error");
        }
      });
    }
  }

  setLocalLinerQuantity(partNumber, quantity) {
    const e = { target: { value: quantity } };
    if (!IsInputExcessive(e, "Quantity")) {
      var formState = this.state.formState
      var liners = formState.currentLiners;
      liners = this.state.formState.currentLiners.map((liner) => {
        if (liner.partNumber === partNumber) {
          liner.quantity = quantity;
        }

        return liner;
      });

      formState.currentLiners = liners;
      this.setState({
        formState: formState
      });
    }
  }

  addLinerFromPartNumber() {
    var formState = this.state.formState;

    let partNumber = formState.linerPartNumber.value;
    let quantity = formState.linerQuantity.value;
    partNumber = partNumber?.trim();
    if (!partNumber) {
      return;
    }

    this.addLinerRequest(partNumber, quantity);

    formState.linerPartNumber.value = "";
    formState.linerQuantity.value = 1;

    this.setState({
      formState: formState
    });
  }

  addLinerFromSelection() {
    var formState = this.state.formState;

    let partNumber = formState.selectedLinerPartNumber;
    let quantity = formState.linerQuantity.value;
    partNumber = partNumber?.trim();
    if (!partNumber) {
      return;
    }

    this.addLinerRequest(partNumber, quantity);

    formState.linerQuantity.value = 1;
    formState.selectedLinerPartNumber = null;

    this.setState({
      formState: formState
    });
  }

  async addLinerRequest(partNumber, quantity) {
    let isMulti = null;
    if (this.props.productsAdded) {
      const productsAdded = await this.props.productsAdded();
      isMulti = this.checkIsMulti(productsAdded);
    }

    apiClient.post(
      `addLiner/${this.props.formTypeId}?isMulti=${isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`,
      {
        partnumber: partNumber,
        quantity: quantity
      }
    ).then(response => {
      if (response.data.success) {
        if (response.data.leadTimeDays >= 10) {
          CreateNotification("This liner has a lead time of up to " + response.data.leadTimeDays
            + " days. If you need this liner sooner, please consult WillowWood Customer Care at 1-800-848-4930."
            , "warning"
            , "top-right"
            , false
            , true
            , true
            , false)
        }
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }

  async loadCart() {
    var saveLiners = (cartData) => {
      let liners = cartData.map((item) => {
        if (item === null) {
          return null;
        }

        return {
          name: item.name,
          partNumber: item.partNumber,
          quantity: item.quantity,
          sourceId: item.sourceId,
          formIndex: item.formIndex,
        };
      });

      let cartWithIndex = Object.groupBy(liners, ({ formIndex }) => formIndex);
      if ("null" in cartWithIndex) {
        cartWithIndex = Object.groupBy(liners, ({ sourceId }) => sourceId);
      }
      const formIndexedCart = Object.values(cartWithIndex);

      var formState = this.state.formState;
      formState.currentLiners = liners;
      formState.indexedCurrentLiners = formIndexedCart;
      this.setState({
        formState: formState
      });
    }
    saveLiners = saveLiners.bind(this);

    let currentBasket = null;
    let isMulti = null;
    if (this.props.productsAdded) {
      const productsAdded = await this.props.productsAdded();
      isMulti = this.checkIsMulti(productsAdded);
      if (isMulti) {
        currentBasket = await this.props.getProductBasket(this.props.parentFormTypeId);
      }
    }

    let url = `cart/`;
    if (isMulti) {
      url += `${this.props.parentFormTypeId}?isMulti=${isMulti}&basketId=${currentBasket?.id}`
    } else {
      url += `${this.props.formTypeId}`
    }

    await apiClient.get(
      url
    ).then(response => {
      this.props.setTempCart(response.data);
      saveLiners(response.data);
      this.props.loadCart();
    }).catch(error => {
      console.log(error)
    });

    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);
    let currentInterface = this.state.formState.linerInterface.value;
    let currentProfile = this.state.formState.linerProfile.value;
    let currentSize = this.state.formState.linerSize.value;

    let partnumber = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface
        && c.profileId === currentProfile
        && c.sizeId === currentSize
        && c.suspension === currentSuspension
    )[0]?.partNumber;

    var formState = this.state.formState;
    formState.selectedLinerPartNumber = partnumber;

    this.setState({ formState: formState, hasDataChanged: true });

  }

  isRequired() {
    return false;
  }

  updateRequirements() {
    var formState = this.state.formState;
    var required = this.isRequired();

    formState.linerInterface.isRequired = required;
    formState.linerSize.isRequired = required;
    formState.linerProfile.isRequired = required;
    formState.linerQuantity.isRequired = required;

    this.setState({
      formState: formState
    });
  }

  onInputChange(e, id) {
    if (!IsInputExcessive(e, id)) {
      let formState = this.state.formState;
      formState.linerQuantity.value = e.target.value;
      this.setState({
        formState: formState,
        hasDataChanged: true,
      });
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.updateCartEditor !== this.props.updateCartEditor) {
      let formState = this.state.formState;
      formState.currentLiners = [];
      this.setState({ formState: formState });
      this.props.setUpdateCartEditor(false)
    }
  }

  async loadData() {
    this.setState({
      linerSuspensions: (
        await apiClient.get("fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerSuspension" },
          }
        )
      ).data,
      linerInterfaces: (
        await apiClient.get("fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerInterface" },
          }
        )
      ).data,
      linerSizes: (
        await apiClient.get("fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerSize" },
          }
        )
      ).data,
      linerProfiles: (
        await apiClient.get("fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerProfile" },
          }
        )
      ).data,
    });

    this.setState({
      linerOptionCombinations: (
        await apiClient.get("liners/" + this.props.formTypeId)
      ).data
    });

    await this.loadCart();
    this.setState({ isLoaded: true });
  }

  async saveData() {
    let totalNoOfLiners = 0;
    if (this.state.formState.currentLiners !== null) {
      this.state.formState.currentLiners.filter(cl => cl.sourceId === 'liner').forEach(cl => {
        totalNoOfLiners += parseInt(cl.quantity);
      })
    }

    if (totalNoOfLiners === 0) {
      let notification = "Cannot proceed with no Liners added.";
      // need to use props.isMulti here becuase that is what renders the button
      if (this.props.isMulti) {
        const formName = MultiFormNames[this.props.parentFormTypeId];
        notification += ` If you would like to proceed with ${formName} only, select "Remove Form" at bottom of page.`;
      }

      if (this.props.isMulti) {
        CreateNotification(notification
          , "error"
          , "top-right"
          , false
          , true
          , true
          , false);
      } else {
        CreateNotification(notification, "error");
      }

      return null;
    }

    let isMulti = null;
    if (this.props.productsAdded) {
      const productsAdded = await this.props.productsAdded();
      isMulti = this.checkIsMulti(productsAdded);
    }

    let data = [];

    return await apiClient.post(
      "fieldInputs/" + this.props.formTypeId + "?isMulti=" + isMulti + "&parentFormTypeId=" + this.props.parentFormTypeId,
      data
    );
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  async saveIds(addedFormTypeIDs) {
    addedFormTypeIDs = addedFormTypeIDs.filter(p => p !== "");
    const formTypeIdsToAddJson = addedFormTypeIDs.toString();

    let data = [];
    data.push({
      fieldName: "addedFormTypeIDs",
      stringData: formTypeIdsToAddJson,
    });

    return await apiClient.post(
      "fieldInputs/" + this.props.parentFormTypeId,
      data
    )
  }

  async removeProduct(name) {
    try {
      const formData = await this.props.getFormData();
      const fd = formData.find(f => f.name === name);
      if (fd) {
        let idToRemove = fd.formContent.props.formTypeId;
        const currentAddedFormTypeIDs = await this.props.productsAdded();
        let addedFormTypeIDs = currentAddedFormTypeIDs.split(",").filter(id => id !== '');
        addedFormTypeIDs = addedFormTypeIDs.filter(i => parseInt(i) !== idToRemove);
        this.props.setFormTypeIdsToAdd(addedFormTypeIDs);
        await this.props.removeProduct(fd);
        await this.saveIds(addedFormTypeIDs);
        this.props.loadCart();
        this.props.getFormData();
        CloseNotification();
      }
    } catch (ex) {
      this.setState({
        isLoading: false
      });
      console.log(ex);
    }
  }

  checkIsMulti(productsAdded) {
    return (productsAdded && productsAdded !== '') ? true : null
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    let validSuspensions = this.state.linerSuspensions;
    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);

    let validProfiles = this.state.linerProfiles.filter(p =>
      this.state.linerOptionCombinations.some(c => c.profileId === p.id
        && c.suspension === currentSuspension)
    );
    let currentProfile = this.state.formState.linerProfile.value;

    let validInterfaces = this.state.linerInterfaces.filter(i =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === i.id
        && c.suspension === currentSuspension
        && c.profileId === currentProfile)
    );
    let currentInterface = this.state.formState.linerInterface.value;

    let validSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface
        && c.profileId === currentProfile
        && c.sizeId === s.id
        && c.suspension === currentSuspension)
    );
    let validCylindricalSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface
        && c.profileId === currentProfile
        && c.sizeId === s.id
        && c.suspension === currentSuspension
        && c.sizeGuide === "TruSealCylindrical")
    );
    let validConicalSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface
        && c.profileId === currentProfile
        && c.sizeId === s.id
        && c.suspension === currentSuspension
        && c.sizeGuide === "TruSealConical")
    );
    let currentSize = this.state.formState.linerSize.value;

    let hasBothCs = validConicalSizes.length > 0 && validCylindricalSizes.length > 0;

    let combos = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface
        && c.profileId === currentProfile
        && c.suspension === currentSuspension
    );
    let sizeGuide = combos[0]?.sizeGuide;
    let partnumber = combos.filter(c => c.sizeId === currentSize)[0]?.partNumber;

    let image = null;
    switch (sizeGuide) {
      case "TPEProgressive": image = TPEProgessiveSizeGuide;
        break;
      case "TPEUniform": image = TPEUniformSizeGuide;
        break;
      case "TPESymmetrical": image = TPESymmetricalSizeGuide;
        break;
      case "SiliconeProgressive": image = SiliconeProgressiveSizeGuide;
        break;
      case "SiliconeSymmetrical": image = SiliconeSymmetricalSizeGuide;
        break;
      case "SiliconeUniform": image = SiliconeUniformSizeGuide;
        break;
      case "TruSealCylindrical": image = TruSealCylindricalSizeGuide;
        break;
      case "TruSealConical": image = TruSealConicalSizeGuide;
        break;
      //TODO rest of images
      default: image = null;
    }

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => { e.preventDefault() }}>

            <div className="fieldBorder">
              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Quick Entry</b></h4>
                <br />
                <p><a target="_blank" rel="noreferrer" href="https://willowwood.com/product-category/products/liners/">Click here to find your Alpha Liner Part Number</a></p>
                <p>Use this section to add a liner to your order if you already know the part number. Enter the Part Number below, update Quantity desired and “Add” to Cart.</p>
                <p className="font-italic text-secondary">Example Part Number H352-6394.</p>
              </div>
              <div className="fieldWrapper" style={{ paddingTop: '10px' }}>
                <InputTextField
                  label="Part Number"
                  variant="outlined"
                  placeholder=""
                  type="text"
                  width="384px"
                  required={false}
                  value={this.state.formState.linerPartNumber.value}
                  onChange={(e) => {
                    if (!IsInputExcessive(e, "linerPartNumber")) {
                      let formstate = this.state.formState;
                      formstate.linerPartNumber.value = e.target.value.toUpperCase();
                      this.setState({ formState: formstate });
                    }
                  }}
                />
                <InputTextField
                  label="Liner Quantity"
                  variant="outlined"
                  placeholder=""
                  type="number"
                  width="384px"
                  required={false}
                  value={this.state.formState.linerQuantity.value}
                  onChange={(e) => this.onInputChange(e, "LinerQuantity")}
                />
                <div style={{ paddingTop: '20px' }}>
                  <SecondaryButton
                    text="Add"
                    onClick={this.addLinerFromPartNumber}
                  />
                </div>
              </div>
            </div>

            <br />

            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"><b>Liner Part Number Wizard</b></h4>
              <br />
              <p>Only the following liners are included in the Liner Part Number Wizard:</p>
              <ul>
                <li>ALPHA Classic MP</li>
                <li>ALPHA Hybrid</li>
                <li>ALPHA Silicone</li>
                <li>ALPHA TruSeal</li>
                <li>ALPHA SmartTemp Silicone</li>
                <li>ALPHA SmartTemp TPE</li>
              </ul>
              <p className="red-emphasis">All other liners need to be ordered by SKU via Quick Entry above.</p>
            </div>
            <div className="fieldBorder">
              <MuiRadio
                options={validSuspensions}
                defaultValue={this.state.formState.linerSuspension.value}
                label="Suspension"
                required={this.state.formState["linerSuspension"].isRequired}
                error={this.handleError("linerSuspension") && this.state.isSubmit}
                checked
                onChange={(e) => {
                  this.onRadioChange(e, "linerSuspension");
                }}
              />
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={validProfiles}
                defaultValue={currentProfile}
                label="Profile"
                required={this.state.formState["linerProfile"].isRequired}
                error={this.handleError("linerProfile") && this.state.isSubmit}
                checked
                onChange={(e) => {
                  this.onRadioChange(e, "linerProfile");
                }}
              />
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={validInterfaces}
                defaultValue={currentInterface}
                label="Interface"
                required={this.state.formState["linerInterface"].isRequired}
                error={this.handleError("linerInterface") && this.state.isSubmit}
                checked
                onChange={(e) => {
                  this.onRadioChange(e, "linerInterface");
                }}
              />
            </div>

            {!hasBothCs &&
              <div className="fieldBorder">
                <MuiRadio
                  options={validSizes}
                  defaultValue={currentSize}
                  label="Size"
                  required={this.state.formState["linerSize"].isRequired}
                  error={this.handleError("linerSize") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerSize");
                  }}
                />
                {image && <img src={image} width="800" alt="Size Guide" />}
              </div>
            }

            {hasBothCs &&
              <div className="fieldBorder">
                <div className="radioGroup">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={currentSize}
                      defaultValue={currentSize}
                      onChange={(e) => {
                        this.onRadioChange(e, "linerSize");
                      }}
                      name="radio-buttons-group"
                      row
                    >
                      <FormLabel id="demo-radio-buttons-group-label">
                        Size
                        {this.state.formState["linerSize"].isRequired ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : (
                          ""
                        )}
                      </FormLabel>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Conical
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {validConicalSizes
                            .map((size) => (
                              <FormControlLabel
                                value={size.id}
                                control={<Radio />}
                                label={
                                  <div className="radioLabel">
                                    <div className="radioIcon">
                                      <span>{size.displayName}</span>
                                    </div>
                                  </div>
                                }
                                className={`${parseInt(this.selectedValue) === size.id || currentSize === size.id
                                    ? "checkedLabel"
                                    : ""
                                  }`}
                              />
                            ))}
                        </div>
                      </div>
                      <img src={TruSealConicalSizeGuide} width="800" alt="Size Guide" />

                      <br />

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Cylindrical
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {validCylindricalSizes
                            .map((size) => (
                              <FormControlLabel
                                value={size.id}
                                control={<Radio />}
                                label={
                                  <div className="radioLabel">
                                    <div className="radioIcon">
                                      <span>{size.displayName}</span>
                                    </div>
                                  </div>
                                }
                                className={`${parseInt(this.selectedValue) === size.id || currentSize === size.id
                                    ? "checkedLabel"
                                    : ""
                                  }`}
                              />
                            ))}
                        </div>
                      </div>
                      <img src={TruSealCylindricalSizeGuide} width="800" alt="Size Guide" />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            }

              <div className="fieldWrapper" style={{ paddingTop: '10px'}}>
                  <InputTextField
                    label="Selected Part Number"
                    variant="outlined"
                    placeholder=""
                    type="text"
                    width="384px"
                    required={false}
                    disabled
                    value={partnumber}
                    
                  />
                  <InputTextField
                    label="Liner Quantity"
                    variant="outlined"
                    placeholder=""
                    type="number"
                    width="384px"
                    required={false}
                    value={this.state.formState.linerQuantity.value}
                    onChange={(e) => this.onInputChange(e, "LinerQuantity")}
                  />
                  <div style={{ paddingTop: '20px'}}>
                  <SecondaryButton
                    text="Add"
                    onClick={this.addLinerFromSelection}
                  />
                  </div>
              </div>
              {this.state.formState.currentLiners.length > 0 && 
                <div className="fieldBorder">
                  <br />
                  <div className="msgBox msgBoxWidth">
                    <h4 className="headLable"><b>{`Current ${this.props.isMulti ? 'Products' : 'Liners'} in Cart`}</b></h4>
                  </div>
                  <br />
                  <Table className="transparent-table">
                  <thead>
                    <tr>
                      <th><b>{`${this.props.isMulti ? 'Product' : 'Liner'}`}</b></th>
                      <th></th>
                      <th><b>Part Number</b></th>
                      <th><b>Quantity</b></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.formState.indexedCurrentLiners.map((indexedLiner, index) => {
                      return (
                        <React.Fragment key={index}>
                          {this.props.isMulti && <tr className="th-border" colSpan={5}><td className="th-padding"><b>{ToCamelCase(indexedLiner[0].sourceId)}</b></td></tr>}
                          {indexedLiner.map((liner, index) => {
                            if (liner === null) {
                              return "";
                            }
                            return (
                              <tr key={`${liner.partNumber}_${index}`}>
                                <td lg="6" sm="1">
                                  <div>{liner.name}</div>
                                </td>
                                <td></td>
                                <td>
                                  <div>{liner.partNumber}</div>
                                </td>
                                <td>
                                  <TextField
                                    type={"number"}
                                    onChange={(e) => {
                                      if (liner.sourceId !== 'liner') {
                                        CreateNotification("Can only adjust quantity of Liner products from this page.", "error");
                                      } else {
                                        this.setLocalLinerQuantity(liner.partNumber, e.target.value);
                                      }
                                    }}
                                    onBlur={() => {
                                      if (liner.sourceId === 'liner') {
                                        this.setServerLinerQuantity(liner.partNumber, liner.quantity);
                                      }
                                    }}
                                    value={liner.quantity}
                                  />
                                </td>
                                <td><SecondaryButton
                                  text="Remove"
                                  onClick={() => {
                                    if (liner.sourceId !== 'liner') {
                                      CreateNotification("Can only remove Liner products from this page.", "error");
                                    } else {
                                      this.setServerLinerQuantity(liner.partNumber, 0)
                                    }
                                  }}
                                />
                                </td>
                              </tr>
                            )
                          })}
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            }
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            {this.props.isMulti && this.props.parentFormTypeId !== this.formTypeId ?
              <SecondaryButton
                text={`Remove Form`}
                onClick={async () => {
                  this.setState({
                    isLoading: true
                  })
                  await this.removeProduct("Liner");
                }}
                disabled={this.state.isLoading}
              />
              : <></>}
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack()}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext();
                    CloseNotification();
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId={this.props?.isMulti ? this.props.parentFormTypeId : this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
          isMulti={this.props.isMulti}
        />
      </>
    );
  }
}